export default __webpack_public_path__ + "static/media/chronos-fire-active.ed0e2b85.svg";